import {
  EVENT_TYPE_AUTHORIZATION_REQUEST,
  EVENT_TYPE_END_CHARGING_SESSION,
  EVENT_TYPE_EV_CONNECTED,
  EVENT_TYPE_EV_DISCONNECTED,
  EVENT_TYPE_FAULT,
  EVENT_TYPE_FINISH_APPLYING_LIMIT,
  EVENT_TYPE_OFFLINE,
  EVENT_TYPE_ONLINE,
  EVENT_TYPE_START_APPLYING_LIMIT,
  EVENT_TYPE_START_CHARGING_SESSION,
  EVENT_TYPE_START_DISCHARGING_SESSION,
} from '../../LogEvents/helper';
import { makeCharger, makeEvent, makeLine } from '../helper';
import { CONSTRAINTS } from '../../../../../common/constants/plaza/graphs/_demo/data/constants';

const defaultEventValuesByType = {
  [EVENT_TYPE_EV_CONNECTED]: {
    current_requested: 100,
    number_of_phases: 1,
  },
  [EVENT_TYPE_EV_DISCONNECTED]: {},
  [EVENT_TYPE_AUTHORIZATION_REQUEST]: {
    current_requested: 100,
    energy_requested: 1,
  },
  [EVENT_TYPE_START_APPLYING_LIMIT]: {
    current_limit: 75.0,
  },
  [EVENT_TYPE_FINISH_APPLYING_LIMIT]: {
    current_limit: 75.0,
  },
  [EVENT_TYPE_START_CHARGING_SESSION]: {
    session_id: '16546DS65A',
    session_type: '15118_DC',
    start_time: 1544717036,
  },
  [EVENT_TYPE_START_DISCHARGING_SESSION]: {
    session_id: '16546DS65A',
    session_type: '15118_DC',
    start_time: 1544717036,
  },
  [EVENT_TYPE_END_CHARGING_SESSION]: {
    session_id: '16546DS65A',
    session_type: '15118_DC',
    start_time: 1544717036,
    departure_time: 1544717036 + 3650,
    end_time: 1544717036 + 3600,
  },
};

const plazaUuid = 'a81be6fe-a026-467b-bc36-1be3bc9d95b0';

const CHARGERS = [
  makeCharger(plazaUuid, 'Ch-11', 'IOT00120C2DF6CB4D01'),
  makeCharger(plazaUuid, 'Ch-12', 'IOT00120C2DF7AA41Q5'),
  makeCharger(plazaUuid, 'Ch-21', 'IOT00120C2DF7AW4126'),
  makeCharger(plazaUuid, 'Ch-13'),
];

const makeValuableEvent = (chargers, eventType, values) => makeEvent(chargers, eventType, values || defaultEventValuesByType[eventType]);

const settings = {
  margin: 15,
  root: {
    x: 975, y: 10, h: 212,
  },
};

const setSettings = (nodeName, parent, nodeHeight = 0, margin = 0) => {
  if (!settings[nodeName]) {
    settings[nodeName] = {};
  }

  settings[nodeName].y = parent.y + parent.h + (margin || settings.margin);
  if (nodeHeight) {
    settings[nodeName].h = nodeHeight;
  }

  return settings[nodeName].y;
};
const getNodeSettings = (nodeName) => settings[nodeName];

export const nodes = {
  topology: {
    children: [
      {
        children: [
          {
            children: [
              {
                children: [
                  {
                    children: [],
                    id: '634254c2-1737-4c48-8571-c3fc2d68c654',
                  },
                  {
                    children: [],
                    id: '2e9951d6-09cc-4bf3-87e2-ab6f61ff8db1',
                  },
                  {
                    children: [],
                    id: 'bd1a5d97-1c8f-4a22-b982-a246ecbd768f',
                  },
                ],
                id: 'e49d4fc3-0751-4442-a5b9-f7c2393cdfb8',
              },
              {
                children: [
                  {
                    children: [],
                    id: 'c789482a-674d-47ba-bf32-580f941fede8',
                  },
                  {
                    children: [],
                    id: '37ec7c38-1080-4acf-a751-34bbc35a3027',
                  },
                ],
                id: '9267ae60-9732-454a-9606-13f961fc9303',
              },
              // Policy
              // {
              //   id: 'e49d4fc3-0751-4442-a5b9-f7c2393cdfb9',
              //   children: []
              // },
              {
                children: [
                  {
                    children: [],
                    id: 'e20eefe1-3eb8-494b-8f68-6a9dc7ca6acd',
                  },
                  {
                    children: [
                      {
                        children: [],
                        id: '1d6aae3f-04e9-4a19-b82f-6b30e1ebab7b',
                      },
                    ],
                    id: 'd15c0fec-6174-4907-ae09-3c61fb4a6a56',
                  },
                ],
                id: 'c6de84d0-9f3b-48b9-b7f5-2df27c952650',
              },
            ],
            id: 'fcc6bd07-9bf6-4a1b-9dc0-4be0071be4a0',
          },
        ],
        id: 'e1544b9b-9615-4dc6-b087-f0dece791112',
      },
    ],
    id: 'bebdae1c-90b8-40eb-b131-285368b278b0', // rootNode
  },
  nodeList: [
    // Root
    {
      id: 'bebdae1c-90b8-40eb-b131-285368b278b0',
      topologyNodeType: 'ROOT',
      staticSection: {
        positionX: settings.root.x,
        positionY: settings.root.y,
        maxCurrentLimit: '250',
        nodeName: 'Grid',
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
        },
        schedules: [
          {
            dayType: 'WEEKENDS',
            items: [
              {
                type: 'PGE',
                cost: 0,
                from: 0,
                maxPeakDemand: 0,
                pgePeriod: 'OFF_PEAK',
                to: 86399,
              },
            ],
          },
          {
            dayType: 'WEEKDAYS',
            items: [
              {
                type: 'PGE',
                cost: '5',
                from: 0,
                maxPeakDemand: '3',
                pgePeriod: 'OFF_PEAK',
                to: 82800,
              },
              {
                type: 'PGE',
                cost: '5',
                from: 82800,
                maxPeakDemand: '3',
                pgePeriod: 'PARTIAL_PEAK',
                to: 86399,
              },
            ],
          },
        ],
        voltage: '230',
      },
    },
    {
      id: 'e1544b9b-9615-4dc6-b087-f0dece791112',
      topologyNodeType: 'POWER_SOFT_CONSTRAINT',
      staticSection: {
        positionX: settings.root.x,
        positionY: setSettings('Grid Demand Limiter', settings.root, 176),
        maxCurrentLimit: '250',
        maxPower: '170',
        nodeName: 'Grid Demand Limiter',
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
        },
        schedules: [
          {
            dayType: 'WEEKDAYS',
            items: [
              {
                type: 'LOAD_MAX_LIMIT',
                from: 0,
                to: 86399,
                maxLoad: '100',
              },
            ],
          },
          {
            dayType: 'WEEKENDS',
            items: [
              {
                type: 'LOAD_MAX_LIMIT',
                from: 0,
                to: 86399,
                maxLoad: '100',
              },
            ],
          },
        ],
      },
    },
    // Junction
    {
      id: 'fcc6bd07-9bf6-4a1b-9dc0-4be0071be4a0',
      topologyNodeType: 'JUNCTION',
      staticSection: {
        positionX: settings.root.x + 10,
        positionY: setSettings('J1', getNodeSettings('Grid Demand Limiter'), 40),
        nodeName: 'J1',
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
        },
      },
    },
    // Breakers
    {
      id: 'e49d4fc3-0751-4442-a5b9-f7c2393cdfb8',
      topologyNodeType: 'CONSTRAINT',
      staticSection: {
        positionX: 350,
        // positionY: 530,
        positionY: setSettings(CONSTRAINTS.hc.demo1.title, getNodeSettings('J1'), 210, 40),
        maxCurrentLimit: '110',
        nodeName: CONSTRAINTS.hc.demo1.title,
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
        },
      },
    },
    {
      id: '9267ae60-9732-454a-9606-13f961fc9303',
      topologyNodeType: 'CONSTRAINT',
      staticSection: {
        positionX: settings.root.x,
        // positionY: 530,
        positionY: setSettings(CONSTRAINTS.hc.demo2.title, getNodeSettings('J1'), 210, 40),
        maxCurrentLimit: '155',
        nodeName: CONSTRAINTS.hc.demo2.title,
        phases: {
          relativeRotation: {
            1: '2',
            2: '3',
            3: '1',
          },
          absoluteRotation: {
            1: '2',
            2: '3',
            3: '1',
          },
        },
      },
    },
    {
      id: 'c6de84d0-9f3b-48b9-b7f5-2df27c952650',
      topologyNodeType: 'CONSTRAINT',
      staticSection: {
        positionX: 1350,
        // positionY: 530,
        positionY: setSettings(CONSTRAINTS.hc.demo3.title, getNodeSettings('J1'), 210, 40),
        maxCurrentLimit: '120',
        nodeName: CONSTRAINTS.hc.demo3.title,
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
        },
      },
    },
    // Chargers 11-13
    {
      id: '634254c2-1737-4c48-8571-c3fc2d68c654',
      topologyNodeType: 'CHARGER',
      staticSection: {
        positionX: 100,
        positionY: setSettings('Ch-11', getNodeSettings('Breaker 22')),
        minCurrentLimit: '8',
        condition: 'ACTIVE',
        nodeName: 'Ch-11',
        defaultOfflineCurrentLimit: '10',
        chargerUuid: 'IOT00120C2DF6CB4D01',
        minLoadLimit: 6,
        defaultPower: 1380,
        offlineCurrentLimit: 6,
        state: 'NOT_CONNECTED',
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
        },
        voltage: '230',
      },
    },
    {
      id: '2e9951d6-09cc-4bf3-87e2-ab6f61ff8db1',
      topologyNodeType: 'CHARGER',
      staticSection: {
        positionX: 350,
        positionY: setSettings('Ch-12', getNodeSettings('Breaker 22')),
        minCurrentLimit: '8',
        condition: 'ACTIVE',
        nodeName: 'Ch-12',
        defaultOfflineCurrentLimit: '10',
        chargerUuid: 'IOT00120C2DF7AA41Q5',
        minLoadLimit: 6,
        defaultPower: 1380,
        offlineCurrentLimit: 6,
        state: 'NOT_CONNECTED',
        phases: {
          relativeRotation: {
            1: '3',
            2: '1',
            3: '2',
          },
          absoluteRotation: {
            1: '3',
            2: '1',
            3: '2',
          },
        },
        voltage: '230',
      },
    },
    {
      id: 'bd1a5d97-1c8f-4a22-b982-a246ecbd768f',
      topologyNodeType: 'CHARGER',
      staticSection: {
        positionX: 600,
        positionY: setSettings('Ch-13', getNodeSettings('Breaker 22')),
        minCurrentLimit: '8',
        condition: 'ACTIVE',
        nodeName: 'Ch-13',
        defaultOfflineCurrentLimit: '0',
        chargerUuid: 'IOT00120C65F7A1O7P7',
        minLoadLimit: 6,
        defaultPower: 1380,
        offlineCurrentLimit: 6,
        state: 'NOT_CONNECTED',
        phases: {
          relativeRotation: {
            1: '2',
          },
          absoluteRotation: {
            1: '2',
          },
        },
        voltage: '230',
      },
    },
    // Chargers 21-22
    {
      id: 'c789482a-674d-47ba-bf32-580f941fede8',
      topologyNodeType: 'CHARGER',
      staticSection: {
        positionX: 850,
        positionY: setSettings('Ch-21', getNodeSettings('Breaker 22')),
        minCurrentLimit: '8',
        condition: 'ACTIVE',
        nodeName: 'Ch-21',
        defaultOfflineCurrentLimit: '10',
        chargerUuid: 'IOT00120C2DF7AW4126',
        minLoadLimit: 6,
        defaultPower: 1380,
        offlineCurrentLimit: 6,
        state: 'NOT_CONNECTED',
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '2',
            2: '3',
            3: '1',
          },
        },
        voltage: '230',
      },
    },
    {
      id: '37ec7c38-1080-4acf-a751-34bbc35a3027',
      topologyNodeType: 'CHARGER',
      staticSection: {
        positionX: 1100,
        positionY: setSettings('Ch-22', getNodeSettings('Breaker 22')),
        minCurrentLimit: '8',
        condition: 'ACTIVE',
        nodeName: 'Ch-22',
        defaultOfflineCurrentLimit: '10',
        chargerUuid: 'IOT00120C2DF7CB4C12',
        minLoadLimit: 6,
        defaultPower: 1380,
        offlineCurrentLimit: 6,
        state: 'NOT_CONNECTED',
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '2',
            2: '3',
            3: '1',
          },
        },
        voltage: '230',
      },
    },
    // Charger 31
    {
      id: 'e20eefe1-3eb8-494b-8f68-6a9dc7ca6acd',
      topologyNodeType: 'CHARGER',
      staticSection: {
        positionX: 1350,
        positionY: setSettings('Ch-31', getNodeSettings('Breaker 22')),
        minCurrentLimit: '8',
        condition: 'ACTIVE',
        nodeName: 'Ch-31',
        defaultOfflineCurrentLimit: '10',
        chargerUuid: 'IOT00120C2DF6CB4R23',
        minLoadLimit: 6,
        defaultPower: 1380,
        offlineCurrentLimit: 6,
        state: 'NOT_CONNECTED',
        phases: {
          relativeRotation: {
            1: '3',
          },
          absoluteRotation: {
            1: '3',
          },
        },
        voltage: '230',
      },
    },
    // Meter
    {
      id: 'd15c0fec-6174-4907-ae09-3c61fb4a6a56',
      topologyNodeType: 'MEASUREMENT_POINT',
      staticSection: {
        positionX: 1600,
        positionY: setSettings('Building Meter', getNodeSettings('Breaker 23'), 153),
        nodeName: 'Building Meter',
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
        },
      },
    },
    {
      id: '1d6aae3f-04e9-4a19-b82f-6b30e1ebab7b',
      topologyNodeType: 'LOAD',
      staticSection: {
        positionX: 1600,
        positionY: setSettings('Building 1', getNodeSettings('Building Meter'), 0, 40),
        maxCurrentLimit: '60',
        offlineCurrentLimit: 50,
        maxPower: '40000',
        nodeName: 'Building 1',
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
        },
      },
    },
  ],
  externalSources: [
    {
      id: '5871b0bd-c8af-4c9a-b54d-1c5f4b23a5d3',
      topologyNodeType: 'RENEWABLE',
      staticSection: {
        positionX: 1265,
        positionY: setSettings('PV Panels', settings.root, 130, 50),
        sourceOrdinalNumber: 1,
        maxCurrentLimit: '100',
        withHardConstraint: true,
        withMeasurementPoint: true,
        junctionNodeId: 'fcc6bd07-9bf6-4a1b-9dc0-4be0071be4a0',
        nodeName: 'PV Panels',
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
        },
        voltage: '230',
      },
    },
    {
      id: '101dab48-df09-4f5c-b22f-4d21e999c536',
      topologyNodeType: 'STORAGE',
      staticSection: {
        positionX: 665,
        positionY: setSettings('Battery Wall', settings.root, 147, 50),
        sourceOrdinalNumber: -1,
        maxCurrentLimit: '40',
        withHardConstraint: true,
        withMeasurementPoint: true,
        junctionNodeId: 'fcc6bd07-9bf6-4a1b-9dc0-4be0071be4a0',
        nodeName: 'Battery Wall',
        maxStorageCapacity: 50,
        phases: {
          relativeRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
          absoluteRotation: {
            1: '1',
            2: '2',
            3: '3',
          },
        },
        voltage: '230',
      },
    },
  ],
  source: {
    // Ch11:
    '634254c2-1737-4c48-8571-c3fc2d68c654': {
      chargingLoadRequested: [null, null, null, 22, 22, 22, 22, 22, 22, 22, null, null],
      authorizationRequested: [false, false, true, false, false, false, false, false, false, false, false, false],
      chargingLoadLimit: [null, null, null, 22, 22, 22, 22, 22, 22, 22, null, null],
      applyingLimit: [false, false, false, true, false, false, false, false, false, false, false, false],
      power: [null, null, null, 1000, 5000, 13000, 140000, 15000, 14000, 8000, null, null],
      presentLoadPhA: [null, null, null, null, null, 3, 3, 4, 3, 2, null, null],
      presentLoadPhB: [null, null, null, null, null, 6, 6, 7, 6, 5, null, null],
      presentLoadPhC: [null, null, null, null, null, 9.84, 11.29, 10.74, 11.29, 4.59, null, null],
      presentPowerPhA: [null, null, null, null, null, 3, 3, 4, 3, 2, null, null],
      presentPowerPhB: [null, null, null, null, null, 6, 6, 7, 6, 5, null, null],
      presentPowerPhC: [null, null, null, null, null, 9.84, 11.29, 10.74, 11.29, 4.59, null, null],
      presentVoltagePhA: [null, null, null, null, null, 230, 230, 230, 230, 230, null, null],
      presentVoltagePhB: [null, null, null, null, null, 230, 230, 230, 230, 230, null, null],
      presentVoltagePhC: [null, null, null, null, null, 230, 230, 230, 230, 230, null, null],
      sessionEnergy: [null, null, null, 5, 20, 77, 110, 120, 132, 154, null, null],
      presentSoc: [null, null, null, 30, 40, 50, 55, 70, 85, 95, null, null],
      sessionType: [null, null, null, 'AC-3Ph-ISO15118', 'AC-3Ph-ISO15118', 'AC-3Ph-ISO15118', 'AC-3Ph-ISO15118', 'AC-3Ph-ISO15118', 'AC-3Ph-ISO15118', null, null, null],
      online: [true, true, true, true, true, true, true, true, true, true, true, true],
      evConnected: [false, true, true, true, true, true, true, true, true, true, false, false],
      energyMode: ['IDLE', 'IDLE', 'IDLE', 'IDLE', 'CHARGING', 'CHARGING', 'CHARGING', 'CHARGING', 'CHARGING', 'CHARGING', 'IDLE', 'IDLE'],
      chargingError: [false, false, false, false, false, false, true, true, true, true, true, true],
      socStart: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, null, null],
      powerLimit: [3000, 3000, 4000, 6000, 10000, 10000, 10000, 10000, 10000, 10000, null, null],
      duration: [null, null, null, null, 123, 124, 125, 126, 127, 128, null, null],
      idTag: [null, null, null, null, '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', null, null],
      sessionId: [null, null, null, null, '1116119655889264900', '1116119655889264900', '1116119655889264900', '1116119655889264900', '1116119655889264900', '1116119655889264900', null, null],
      energyDirection: [null, null, null, null, 'UNSPECIFIED', 'UNSPECIFIED', 'IN', 'IN', 'IN', 'UNSPECIFIED', 'UNSPECIFIED', 'UNSPECIFIED'],
      state: ['NOT_CONNECTED', 'CONNECTED_NOT_CHARGING', 'CONNECTED_NOT_CHARGING', 'CONNECTED_NOT_CHARGING', 'CONNECTED_CHARGING', 'CONNECTED_CHARGING', 'CONNECTED_CHARGING', 'CONNECTED_CHARGING', 'CONNECTED_CHARGING', 'CONNECTED_CHARGING', 'NOT_CONNECTED', 'NOT_CONNECTED'],
      energySplitGrid: [null, null, null, 75.00, 100.00, 80.00, 20.00, 5.00, 5.00, 20.00, null, null],
      energySplitRenewable: [null, null, null, 20.00, 0.00, 20.00, 80.00, 80.00, 70.00, 50.00, null, null],
      energySplitStorage: [null, null, null, 5.00, 0.00, 0.00, 0.00, 15.00, 25.00, 30.00, null, null],
    },
    // Ch12:
    '2e9951d6-09cc-4bf3-87e2-ab6f61ff8db1': {
      chargingLoadRequested: [null, null, null, null, null, null, null, null, null, null, null, null],
      authorizationRequested: [false, false, false, false, false, false, false, false, false, false, false, false],
      chargingLoadLimit: [null, null, null, 15, 15, 15, 15, 15, null, null, null, null],
      applyingLimit: [false, false, false, false, false, false, false, false, false, false, false, false],
      power: [null, null, null, null, null, null, null, null, null, null, null, null],
      presentLoadPhA: [null, null, null, 3, 4, 3, 0, 0, null, null, null, null],
      presentLoadPhB: [null, null, null, 7, 6, 7, 7, 6, null, null, null, null],
      presentLoadPhC: [null, null, null, 0, 0, 0, 3, 4, null, null, null, null],
      presentPowerPhA: [null, null, null, 3, 4, 3, 0, 0, null, null, null, null],
      presentPowerPhB: [null, null, null, 7, 6, 7, 7, 6, null, null, null, null],
      presentPowerPhC: [null, null, null, 0, 0, 0, 3, 4, null, null, null, null],
      presentVoltagePhA: [null, null, null, null, null, null, null, null, null, null, null, null],
      presentVoltagePhB: [null, null, null, null, null, null, null, null, null, null, null, null],
      presentVoltagePhC: [null, null, null, null, null, null, null, null, null, null, null, null],
      sessionEnergy: [null, null, null, null, null, null, null, null, null, null, null, null],
      presentSoc: [null, null, null, null, null, null, null, null, null, null, null, null],
      sessionType: [null, null, null, null, null, null, null, null, null, null, null, null],
      online: [true, true, true, false, false, false, false, false, true, true, true, true],
      evConnected: [false, false, false, false, false, false, false, false, false, false, false, false],
      energyMode: ['IDLE', 'IDLE', 'IDLE', 'IDLE', 'IDLE', 'IDLE', 'IDLE', 'IDLE', 'IDLE', 'IDLE', 'IDLE', 'IDLE'],
      chargingError: [false, false, false, false, false, false, false, false, false, false, false, false],
      socStart: [null, null, null, null, null, null, null, null, null, null, null, null],
      powerLimit: [null, null, null, null, null, null, null, null, null, null, null, null],
      duration: [null, null, null, null, null, null, null, null, null, null, null, null],
      idTag: [null, null, null, null, null, null, null, null, null, null, null, null],
      sessionId: [null, null, null, null, null, null, null, null, null, null, null, null],
      energyDirection: [null, null, null, null, null, null, null, null, null, null, null, null],
      state: ['NOT_CONNECTED', 'NOT_CONNECTED', 'NOT_CONNECTED', 'NOT_CONNECTED', 'NOT_CONNECTED', 'NOT_CONNECTED', 'NOT_CONNECTED', 'NOT_CONNECTED', 'NOT_CONNECTED', 'NOT_CONNECTED', 'NOT_CONNECTED', 'NOT_CONNECTED'],
      energySplitGrid: [null, null, null, 75.00, 100.00, 80.00, 20.00, 5.00, null, null, null, null],
      energySplitRenewable: [null, null, null, 20.00, 0.00, 20.00, 80.00, 80.00, null, null, null, null],
      energySplitStorage: [null, null, null, 5.00, 0.00, 0.00, 0.00, 15.00, null, null, null, null],
    },
    // Ch13:
    'bd1a5d97-1c8f-4a22-b982-a246ecbd768f': {
      chargingLoadRequested: [],
      authorizationRequested: [],
      chargingLoadLimit: [],
      applyingLimit: [],
      power: [],
      presentLoad: [],
      presentVoltage: [],
      presentEnergy: [],
      presentSoc: [],
      sessionType: [],
      online: [],
      evConnected: [],
      energyMode: [],
      chargingError: [],
      socStart: [],
      powerLimit: [],
      duration: [],
      idTag: [],
      sessionId: [],
    },
    // Ch21:
    'c789482a-674d-47ba-bf32-580f941fede8': {
      chargingLoadRequested: [null, null, null, null, 15, 15, 15, 15, 15, 15, 15, null],
      authorizationRequested: [false, false, true, false, false, false, false, false, false, false, false, false],
      chargingLoadLimit: [null, null, null, null, 15, 15, 15, 15, 15, 15, 15, null],
      applyingLimit: [false, false, false, true, false, false, false, false, false, false, false, false],
      power: [null, null, null, null, 2000, 3000, 8000, 8000, 7000, 8000, 5000, null],
      presentLoadPhA: [null, null, null, null, 2.9, 4.35, 11.59, 11.59, 10.14, 11.59, 7.25, null],
      presentLoadPhB: [null, null, null, null, 0, 0, 0, 0, 0, 0, 0, null],
      presentLoadPhC: [null, null, null, null, 0, 0, 0, 0, 0, 0, 0, null],
      presentPowerPhA: [null, null, null, null, 2.9, 4.35, 11.59, 11.59, 10.14, 11.59, 7.25, null],
      presentPowerPhB: [null, null, null, null, 0, 0, 0, 0, 0, 0, 0, null],
      presentPowerPhC: [null, null, null, null, 0, 0, 0, 0, 0, 0, 0, null],
      presentVoltagePhA: [null, null, null, null, 230, 230, 230, 230, 230, 230, null, null],
      presentVoltagePhB: [null, null, null, null, 230, 230, 230, 230, 230, 230, null, null],
      presentVoltagePhC: [null, null, null, null, 230, 230, 230, 230, 230, 230, null, null],
      sessionEnergy: [null, null, null, null, 1, 20, 45, 50, 73, 96, 124, null],
      presentSoc: [null, null, null, null, 30, 35, 40, 43, 66, 75, 83, null],
      sessionType: [null, null, null, null, 'AC-3Ph-ISO15118', 'AC-3Ph-ISO15118', 'AC-3Ph-ISO15118', 'AC-3Ph-ISO15118', 'AC-3Ph-ISO15118', 'AC-3Ph-ISO15118', 'AC-3Ph-ISO15118', null],
      online: [true, true, true, true, true, true, true, true, true, true, true, true],
      evConnected: [false, true, true, true, true, true, true, true, true, true, true, false],
      energyMode: ['IDLE', 'IDLE', 'IDLE', 'IDLE', 'CHARGING', 'CHARGING', 'CHARGING', 'CHARGING', 'CHARGING', 'CHARGING', 'CHARGING', 'IDLE'],
      chargingError: [false, false, false, false, false, false, false, false, false, false, false, false],
      socStart: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
      powerLimit: [3000, 3000, 4000, 6000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000],
      duration: [null, null, null, null, 243, 244, 245, 246, 247, 248, null, null],
      idTag: [null, null, null, null, '02AB02F623K6', '02AB02F623K6', '02AB02F623K6', '02AB02F623K6', '02AB02F623K6', '02AB02F623K6', null, null],
      sessionId: [null, null, null, null, '1116119655889263371', '1116119655889263371', '1116119655889263371', '1116119655889263371', '1116119655889263371', '1116119655889263371', null, null],
      energyDirection: [null, null, null, null, 'UNSPECIFIED', 'UNSPECIFIED', 'IN', 'IN', 'IN', 'IN', 'IN', null],
      state: ['NOT_CONNECTED', 'CONNECTED_NOT_CHARGING', 'CONNECTED_NOT_CHARGING', 'CONNECTED_NOT_CHARGING', 'CONNECTED_CHARGING', 'CONNECTED_CHARGING', 'CONNECTED_CHARGING', 'CONNECTED_CHARGING', 'CONNECTED_CHARGING', 'CONNECTED_CHARGING', 'CONNECTED_CHARGING', 'NOT_CONNECTED'],
      energySplitGrid: [null, null, null, null, 100.00, 80.00, 20.00, 5.00, 5.00, 20.00, 20.00, null],
      energySplitRenewable: [null, null, null, null, 0.00, 20.00, 80.00, 80.00, 70.00, 50.00, 40.00, null],
      energySplitStorage: [null, null, null, null, 0.00, 0.00, 0.00, 15.00, 25.00, 30.00, 40.00, null],
    },
    // Ch22:
    '37ec7c38-1080-4acf-a751-34bbc35a3027': {
      chargingLoadRequested: [],
      authorizationRequested: [],
      chargingLoadLimit: [],
      applyingLimit: [],
      power: [],
      presentLoad: [],
      presentVoltage: [],
      presentEnergy: [],
      presentSoc: [],
      sessionType: [],
      online: [],
      evConnected: [],
      energyMode: [],
      energyDirection: [],
      chargingError: [],
      socStart: [],
      powerLimit: [],
      duration: [],
      idTag: [],
      sessionId: [],
    },
    // Ch31:
    'e20eefe1-3eb8-494b-8f68-6a9dc7ca6acd': {
      chargingLoadRequested: [],
      authorizationRequested: [],
      chargingLoadLimit: [],
      applyingLimit: [],
      power: [],
      presentLoad: [],
      presentVoltage: [],
      presentEnergy: [],
      presentSoc: [],
      sessionType: [],
      online: [],
      evConnected: [],
      energyMode: [],
      energyDirection: [],
      chargingError: [],
      socStart: [],
      powerLimit: [],
      duration: [],
      idTag: [],
      sessionId: [],
    },
    // Load 1:
    '1d6aae3f-04e9-4a19-b82f-6b30e1ebab7b': {
      power: [null, null, null, 1035, 2001, 3001, 7997, 7997, 6996, 7997, 5003, null],
      energyDirection: [null, null, null, 'UNSPECIFIED', 'UNSPECIFIED', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', null],
      presentLoad: [null, null, null, 1.5, 2.9, 4.35, 11.59, 11.59, 10.14, 11.59, 7.25, null],
    },
    // Meter S:
    'd15c0fec-6174-4907-ae09-3c61fb4a6a56': {
      presentLoadPhA: [null, null, null, null, 2.9, 4.35, 11.59, 11.59, 10.14, 11.59, 7.25, null],
      presentLoadPhB: [null, null, null, null, 0, 0, 0, 0, 0, 0, 0, null],
      presentLoadPhC: [null, null, null, null, 0, 0, 0, 0, 0, 0, 0, null],
      presentPowerPhA: [null, null, null, null, 2.9, 4.35, 11.59, 11.59, 10.14, 11.59, 7.25, null],
      presentPowerPhB: [null, null, null, null, 0, 0, 0, 0, 0, 0, 0, null],
      presentPowerPhC: [null, null, null, null, 0, 0, 0, 0, 0, 0, 0, null],
    },
    // Junction:
    'fcc6bd07-9bf6-4a1b-9dc0-4be0071be4a0': {
      energyDirection: [null, null, null, 'UNSPECIFIED', 'UNSPECIFIED', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', null],
      energySplitGrid: [null, null, null, 75.00, 100.00, 80.00, 20.00, 5.00, 5.00, 20.00, 20.00, null],
      energySplitRenewable: [null, null, null, 20.00, 0.00, 20.00, 80.00, 80.00, 70.00, 50.00, 40.00, null],
      energySplitStorage: [null, null, null, 5.00, 0.00, 0.00, 0.00, 15.00, 25.00, 30.00, 40.00, null],
    },
    // Soft Constraint 1:
    'e1544b9b-9615-4dc6-b087-f0dece791112': {
      power: [null, null, null, 1000, 5000, 13000, 14000, 15000, 14000, 8000, 4000, null],
      presentLoad: [null, null, null, 16.45, 12.25, 33.84, 35.29, 36.74, 20.29, 11.59, 5.8, null],
    },
    // Breaker 21:
    'e49d4fc3-0751-4442-a5b9-f7c2393cdfb8': {
      presentLoad: [null, null, null, 16.45, 22.25, 33.84, 35.29, 36.74, 20.29, 11.59, 5.8, null],

      energySplitGrid: [null, null, null, 75.00, 100.00, 80.00, 20.00, 5.00, null, null, null, null],
      energySplitRenewable: [null, null, null, 20.00, 0.00, 20.00, 80.00, 80.00, null, null, null, null],
      energySplitStorage: [null, null, null, 5.00, 0.00, 0.00, 0.00, 15.00, null, null, null, null],
    },
    // Breaker 22:
    '9267ae60-9732-454a-9606-13f961fc9303': {
      presentLoad: [null, null, null, null, 2.9, 4.35, 11.59, 11.59, 10.14, 11.59, 7.25, null],

      energySplitGrid: [null, null, null, null, 100.00, 80.00, 20.00, 5.00, null, null, null, null],
      energySplitRenewable: [null, null, null, null, 0.00, 20.00, 80.00, 80.00, null, null, null, null],
      energySplitStorage: [null, null, null, null, 0.00, 0.00, 0.00, 15.00, null, null, null, null],
    },
    // Breaker 23:
    'c6de84d0-9f3b-48b9-b7f5-2df27c952650': {
      presentLoad: [null, null, null, 1.5, 2.9, 4.35, 11.59, 11.59, 10.14, 11.59, 7.25, null],
    },
    // Grid:
    'bebdae1c-90b8-40eb-b131-285368b278b0': {
      presentLoad: [null, null, null, 16.45, 25.15, 38.19, 46.88, 48.33, 30.43, 23.18, 13.05, null],
      pgePeriod: makeLine(['PEAK', 12]),
    },
    //  Renewable
    '5871b0bd-c8af-4c9a-b54d-1c5f4b23a5d3': {
      presentLoad: [null, null, null, 4.386666667, 0, 9.5475, 187.52, 773.28, 426.02, 57.95, 26.1, null],
    },
    //  Storage
    '101dab48-df09-4f5c-b22f-4d21e999c536': {
      presentLoad: [null, null, null, 1.096666667, -5, -7.5, 0, 144.99, 152.15, 34.77, 26.1, null],
      power: [null, null, null, 756.7, -3500, -4900, 0, 100043.1, 104983.5, 23991.3, 18009, null],
      present_capacity: [null, null, null, 54, 44, 41, 38, 32, 21, 18, 15, null],
      charging_without_finished: [false, false, false, false, true, true, false, false, false, false, false, false],
    },
    // Charging Policy
    'e49d4fc3-0751-4442-a5b9-f7c2393cdfb9': {
      chargingPolicy: makeLine(['CHARGING_DISCHARGING_ENABLED', 12]),
    },
  },
  events: [
    // 1
    [],
    // 2
    [],
    // 3
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_EV_CONNECTED),
      makeValuableEvent(CHARGERS[2], EVENT_TYPE_EV_CONNECTED),
    ],
    // 4
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_AUTHORIZATION_REQUEST),
      makeValuableEvent(CHARGERS[2], EVENT_TYPE_AUTHORIZATION_REQUEST),
    ],
    // 5
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_FINISH_APPLYING_LIMIT),
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_START_APPLYING_LIMIT),
      makeValuableEvent(CHARGERS[1], EVENT_TYPE_OFFLINE),
      makeValuableEvent(CHARGERS[2], EVENT_TYPE_FINISH_APPLYING_LIMIT),
      makeValuableEvent(CHARGERS[2], EVENT_TYPE_START_APPLYING_LIMIT),
    ],
    // 6
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_START_CHARGING_SESSION),
      makeValuableEvent(CHARGERS[2], EVENT_TYPE_START_CHARGING_SESSION),
    ],
    // 7
    [],
    // 8
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_FAULT),
    ],
    // 9
    [],
    // 10
    [
      makeValuableEvent(CHARGERS[1], EVENT_TYPE_ONLINE),
    ],
    // 11
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_END_CHARGING_SESSION),
      makeValuableEvent(CHARGERS[2], EVENT_TYPE_END_CHARGING_SESSION),
    ],
    // 12
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_EV_DISCONNECTED),
      makeValuableEvent(CHARGERS[2], EVENT_TYPE_EV_DISCONNECTED),
    ],
  ],
};
